/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BuilderNavigationService,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, UserContext } from '@gh/common-shared';

import { DialogService, NotificationService } from '@gh/core-ui';
import { OfficeRolePermissionTree } from '../../resources/office-role-permission-tree.model';
import { OfficeRolePermissionsBusinessService } from '../../resources/office-role-permissions-business.service';

import { AbstractOfficeRolePermissionsTabComponent } from './abstract-office-role-permissions-tab.component';

@Component({
  standalone: false,
  selector: 'gh-office-role-permissions-general-tab',
  templateUrl: 'office-role-permissions-application-tab.component.html',
})
export class OfficeRolePermissionsGeneralTabComponent extends AbstractOfficeRolePermissionsTabComponent {
  constructor(protected route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              protected userContext: UserContext,
              protected notificationService: NotificationService,
              protected dialogService: DialogService,
              private officeRoleBusiness: OfficeRolePermissionsBusinessService,
              private pipelines: FormActionPipelines,
              private commonActions: CommonActions) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<OfficeRolePermissionTree>> {
    return this.pipelines.complete({
      execute: this.commonActions.execute(({ value }) => this.officeRoleBusiness.updateGeneralPermissions(value)),
      finish: ({ value }) => this.refresh(value),
    });
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.form.value.roleId,
      entityType: 'OFFICE_ROLE',
      eventTypeIds: [AelEvents.OfficeRolePermissions.EditedGeneral],
      label: 'lbl_office_roles_general_permissions',
    });
  }
}
